<template>
  <div class="baseUpload">
    <ul class="upload-list-picture-card" v-if="list.length > 0">
      <li class="upload-list-item" v-for="item in list" :key="item.id">
        <div class="img-content">
          <img v-if="!item.isError && !item.isPdf" :src="item.downloadUrl" alt="" />
          <img v-if="item.isError" src="@/assets/images/error_upload.png" alt="" />
          <img v-if="item.isPdf" src="@/assets/images/pdf_bg.png" alt="" />
          <span @click="handleRemoveItem(item, list)" class="closeSpan">
            <i class="iconfont iconwuliao-bohui"></i>
          </span>
          <div class="img-mark">
            <span v-if="!item.isError && !item.isPdf" @click="handlePreview(item)">
              <i class="el-icon-zoom-in"></i>
            </span>
            <span v-if="item.isPdf" @click="handleDownload(item)">
              <i class="iconfont iconcaozuopingtaitubiao_daojiancaozuo"></i>
            </span>
          </div>
        </div>
        <div class="img-name" :class="item.isError ? 'err-img-name' : ''">{{ item.name }}</div>
      </li>
    </ul>
    <div class="upload-right" v-show="!isView && list.length < limit">
      <el-upload
        ref="upload"
        multiple
        :headers="heard"
        :action="uploadUrl"
        :limit="limit"
        :data="uploadData"
        :before-upload="handleBeforeUpload"
        :on-success="handleSuccess"
        :on-remove="handleRemove"
        :on-error="handleError"
        :on-exceed="handleExceed"
        :on-change="handleChange"
        :auto-upload="false"
        :disabled="disabled"
        :list-type="listType"
        :show-file-list="false"
      >
        <i slot="default" class="el-icon-plus"></i>
      </el-upload>
      <div class="img-upload-title">{{ $lang('上传图片') }}</div>
    </div>
    <!-- <BaseImgPreView :visable.sync="preViewVisible" :src.sync="preViewUrl"></BaseImgPreView> -->
  </div>
</template>

<script>
import { RESPONSE_SUCCESS, IMG_URL } from '@constants'

export default {
  name: 'BaseUpload',
  components: {},
  data() {
    return {
      heard: {},
      preViewUrl: '',
      preViewVisible: false,
      fileListLength: 0,
      errorUploadImg: '/assets/images/error_upload.png',
    }
  },
  props: {
    // 单图是否显示预览
    isPreView: {
      type: Boolean,
      default: function() {
        return true
      },
    },
    size: {
      type: Array,
    },
    uploadUrl: {
      type: String,
      default: function() {
        return IMG_URL
      },
    },
    // 上传组件自定义标识，同一页面有多个文件时使用
    uploadKey: {
      type: String,
      default: function() {
        return ''
      },
    },
    // 文件列表显示类型
    listType: {
      type: String,
      default: function() {
        return 'picture-card'
      },
    },
    // 文件列表
    list: {
      type: Array,
      default: function() {
        return []
      },
    },
    fileTypeList: {
      type: Array,
      default: function() {
        return ['png', 'pdf', 'jpg', 'jpeg']
      },
    },
    // 是否禁用图片上传
    disabled: {
      type: Boolean,
      default: function() {
        return false
      },
    },
    // 最大允许上传个数
    limit: {
      type: Number,
      default: function() {
        return 3
      },
    },
    // 是否在选取文件后立即进行上传
    auto: {
      type: Boolean,
      default: function() {
        return true
      },
    },
    // 上传图片参数(必须传的)
    uploadData: {
      type: Object,
      default: function() {
        return {}
      },
    },
    isView: {
      type: Boolean,
      default: function() {
        return false
      },
    },
  },
  created() {
    this.heard = {
      // authToken: JSON.parse(localStorage.getItem('userData')).token,
      authToken: this.$store.state.base.token,
      routeName: this.$route.name,
    }
  },
  watch: {},
  methods: {
    handleClick: function() {
      this.$emit('uploadClick', {
        key: this.uploadKey,
      })
    },
    handleSuccess: function(res, file, fileList) {
      console.log('上传成功', res.data)
      if (res.code === RESPONSE_SUCCESS) {
        const strUrl = res.data.downloadUrl.slice(-4)
        strUrl === '.pdf' ? (res.data.isPdf = true) : null
        this.$emit('uploadSuccess', {
          res: res,
          file: file,
          fileList: fileList,
          key: this.uploadKey,
        })
        this.preViewUrl = ''
        this.preViewVisible = false
      } else {
        fileList.splice(fileList.length - 1, 1) // 上传失败，要将失败的图片清除
        this.$message.error(res.msg)
      }
    },
    handleError: function(err, file, fileList) {
      file.isError = true
      this.$message.error(this.$lang('图片上传失败，请重试'))
      this.$emit('uploadError', { res: err, file: file, fileList: fileList, key: this.uploadKey })
    },
    handlePreview: function(file) {
      this.preViewUrl = file.downloadUrl
      this.preViewVisible = true
    },
    handleRemoveItem: function(file, fileList) {
      this.$emit('uploadRemove', file, fileList, this.uploadKey)
      this.$refs.upload.handleRemove()
    },
    handleRemove: function(file, fileList) {},
    handleExceed: function() {
      this.$message.warning(`${this.$lang('本次上传最多')} ${this.limit}${this.$lang('张图片')}`)
    },
    handleChange: function(file, fileList) {
      const $this = this
      this.$emit('uploadChange', file, fileList, this.uploadKey)
      const type = file.raw.type.split('/')[1]
      const isRtTy = !this.fileTypeList.length || this.fileTypeList.includes(type)
      // console.log('压缩前', file)
      // 压缩图片
      this.compress(file.raw, function(data) {
        fileList.reduce((pre, cur) => {
          if (cur.name === data.name) {
            data.uid = cur.raw.uid
            cur.raw = data
          }
        }, [])
        // console.log('压缩后', data)
        // console.log('上传列表', fileList)
        $this.$refs.upload.submit()
      })
      const isLt5M = file.size / 1024 / 1024 < 5

      if (!isRtTy) {
        //  符号需要中英切换，直接用空格
        const errStr = this.$lang('只能上传') + this.fileTypeList.join(' ') + this.$lang('格式')
        this.$message.error(this.$lang(errStr))
        return
      }
      if (!isLt5M) {
        this.$message.error(this.$lang('上传头像图片大小不能超过5MB!'))
        return
      }
    },
    handleDownload: function(file) {
      window.open(file.downloadUrl, file.name)
    },
    handleBeforeUpload: function(file) {},
    compress(fileObj, callback) {
      try {
        const $this = this
        const image = new Image()
        image.src = URL.createObjectURL(fileObj)
        image.onload = function() {
          // 默认按比例压缩
          let w = this.width
          let h = this.height
          const scale = w / h
          w = fileObj.width || w
          h = fileObj.height || w / scale
          let quality = 0.92 // 默认图片质量为0.92
          // 生成canvas
          const canvas = document.createElement('canvas')
          const ctx = canvas.getContext('2d')
          // 创建属性节点
          const anw = document.createAttribute('width')
          anw.nodeValue = w
          const anh = document.createAttribute('height')
          anh.nodeValue = h
          canvas.setAttributeNode(anw)
          canvas.setAttributeNode(anh)
          ctx.drawImage(this, 0, 0, w, h)
          // 图像质量
          if (fileObj.quality && fileObj.quality <= 1 && fileObj.quality > 0) {
            quality = fileObj.quality
          }
          // quality值越小，所绘制出的图像越模糊
          const data = canvas.toDataURL('image/jpeg', quality)
          // 压缩完成执行回调
          const newFile = $this.dataURLtoFile(data, fileObj.name)
          callback(newFile)
        }
      } catch (e) {
        console.log('压缩失败!')
      }
    },
    dataURLtoFile(dataurl, filename) {
      // 将base64转换为文件
      var arr = dataurl.split(',')
      var mime = arr[0].match(/:(.*?);/)[1]
      var bstr = atob(arr[1])
      var n = bstr.length
      var u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new File([u8arr], filename, { type: mime })
    },
  },
}
</script>
<style lang="scss">
.baseUpload {
  // padding-top: 10px;
  overflow: hidden;
  display: inline-flex;
  // picture-card样式
  .upload-list-picture-card {
    overflow: hidden;
    float: left;
    padding: 0;
    margin: 0;
    padding-top: 5px;
    // display: inline-flex;
    .upload-list-item {
      margin-right: 20px;
      // padding-top: 5px;
      float: left;
      list-style: none;
      height: 140px;
      width: 102px;
      border: none;
      outline: none;
      .img-content {
        width: 98px;
        height: 98px;
        border-radius: 6px;
        border: 1px solid #ddd;
        position: relative;
        // display: inline-flex;

        img {
          width: 100%;
          height: 100%;
        }
        .img-mark {
          position: absolute;
          // top: -1px;
          left: -1px;
          display: none;
          // border-radius: 6px;
          width: calc(100% + 2px);
          // height: calc(100% + 2px);
          height: 28px;
          background: rgba(0, 0, 0, 0.5);
          cursor: default;
          text-align: center;
          color: #fff;
          font-size: 20px;
          background-color: rgba(0, 0, 0, 0.5);
          transition: all 0.3s;
          // line-height: 100px;
          bottom: 1px;
          span {
            display: inline-block;
            i {
              color: #fff;
              font-size: 18px;
              cursor: pointer;
            }
          }
        }
      }
      .img-content:hover {
        .img-mark {
          display: block;
        }
      }
    }
    .img-name {
      font-size: 12px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      text-align: center;
      color: #999999;
      line-height: 28px;
    }
    .err-img-name {
      color: #f5222d;
    }
  }
  // 上传图片
  .upload-right {
    float: left;
    padding-top: 5px;
    position: relative;
    .el-upload {
      height: 100px;
      width: 100px;
      border: 1px solid #ddd;
      cursor: pointer;
    }
    .img-upload-title {
      font-size: 12px;
      color: #999999;
      text-align: center;
      line-height: 28px;
    }
  }
  .el-upload--picture-card {
    line-height: 100px;
  }
  .el-dialog__header {
    border-bottom: 0px solid #dddddd;
  }
  .el-dialog__body {
    // padding-top: 20px;
    text-align: center;
  }
  .el-dialog__body > img {
    width: 50%;
  }
}
</style>
